import React from "react"

export default function FormError({
  isError = false,
  children,
}: {
  isError: boolean
  children: any
}) {
  if (!isError) {
    return null
  }
  return <p className="mt-2 text-sm text-red-500">{children}</p>
}
